import { render, staticRenderFns } from "./RelevantEvents.vue?vue&type=template&id=13f66208&scoped=true&"
import script from "./RelevantEvents.vue?vue&type=script&lang=js&"
export * from "./RelevantEvents.vue?vue&type=script&lang=js&"
import style0 from "./RelevantEvents.vue?vue&type=style&index=0&id=13f66208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f66208",
  null
  
)

export default component.exports